import Service from "../Service";

const resource = "FrzGreenProcessHistory/";

export default {
    list(filter, requestID) {
        return Service.post(resource + "list", filter, {
            params: { requestID: requestID },
        });
    },
    saveIndividual(obj, requestID) {
        return Service.post(resource + "saveIndividual", obj, {
            params: { requestID: requestID },
        });
    },
    prorrateo(obj, requestID) {
        return Service.post(resource + "prorrateo", obj, {
            params: { requestID: requestID },
        });
    },
}
